import { Button, Grid, Paper, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { ApiError } from "../../Api/ApiError";
import { getStudioList } from "../../Api/Store";
import { StudioData } from "../../Objects/StudioInterface";
import { StoreObjectStore } from "../../ObjectStore/StoreObjectStore";
import CategoryTitle from "../atoms/CategoryTitle";
import StudioCard from "../molecules/StudioCard";
import StudioDataEditDialog from "./StudioDataEditDialog";


const StoreDetailStudioEdit: React.FC = () => {
    const { enqueueSnackbar } = useSnackbar()
    const { storeObjectState, storeObjectDispatch } = React.useContext(StoreObjectStore)
    const [studioId, setStudioId] = React.useState<number>()

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const reloadStudioList = React.useCallback(() => {
        if( storeObjectState.storeData?.str_id ) {
            getStudioList(storeObjectState.storeData?.str_id, true, {signal: abortController.signal}).then((studioDataList: StudioData[]) => {
                storeObjectDispatch({type: 'setStudioList', payload: studioDataList})
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
    },[abortController, storeObjectState.storeData?.str_id, storeObjectDispatch, enqueueSnackbar])

    return (
        <Paper sx={{ mt: 2, pb: 2}}>
            <CategoryTitle
                text="スタジオ設定"
            />
            <Stack
                direction="row"
                justifyContent="flex-end"
                sx={{
                    m: 2
                }}
            >
                <Button
                    variant="outlined"
                    onClick={()=>{
                        setStudioId(0)
                    }}
                >スタジオを追加</Button>
            </Stack>
            <Grid container spacing={2}
                sx={{
                    my: 2,
                    px: 2
                }}
            >
                {storeObjectState?.studioList &&
                    storeObjectState.studioList.map( (studioData: StudioData) => (
                        <Grid item xs={12} sm={6} md={4}
                            key={studioData.str_id+"-"+studioData.std_id}
                        >
                            <StudioCard
                                studioData={studioData}
                                onClick={() => {
                                    setStudioId(studioData.std_id)
                                }}
                            />
                        </Grid>
                    ) )
                }
            </Grid>
            <StudioDataEditDialog
                studioId={studioId}
                storeId={storeObjectState?.storeData?.str_id}
                onClose={(isEdit) => {
                    setStudioId(undefined)
                    if( isEdit ) {
                        reloadStudioList()
                    }
                }}
            />
        </Paper>
    );
}

export default StoreDetailStudioEdit